import React from 'react'
import '../Css/ChooseusStyle.css'
import Navbar from './Navbar'

const ChooseUs = () => {
  return (
    <div>
      <Navbar/>
      <div className="container">
        <p className='topPera'> <span>Eagle Eye Security Agency</span>  is Bangladesh’s premium security services company. But what sets us apart is our diligent, incessant pursuit of excellence in our work.</p><br />

          <div className="firstPera">
            <h2 className='chooseUsHeading'>Expertise & Diligence</h2>
            <p className='aboutperagraph'>We provide the widest range of security solutions across all 64 districts of Bangladesh, as well as maintaining a steady international clientele. Our operations are coordinated by the very best of military trained, professional and a dexterous workforce.</p>
            <div className="whyusImage"><img src="https://images.pexels.com/photos/6105483/pexels-photo-6105483.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="" /></div>
          </div>
          <div className="secondPera">
            <h2 className='chooseUsHeading'>Training & Development</h2>
           
            <p className='aboutperagraph'>We have gone beyond security services and constantly pushed the edge of excellence in our training and development regime. We provide military influence training and learning techniques as well as a wholesome technical education in security services and diligence. To balance the rigorous regime we instill recreational and devout religious knowledge in all our graduates. To impart on the job training we have even installed a mock ATM Booth within our academy to train our graduates expertly. Our dedicated training academy is our pride.</p>
            <div className="whyusImage"><img src="https://images.pexels.com/photos/899438/pexels-photo-899438.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="" /></div>

          </div>


          <div className="thirdPera">
            <h2 className='chooseUsHeading'>Our Adaptibility</h2>
            <p className='aboutperagraph'>Eagle Eye Security Service is an unique company working beyond the definition of a traditional security provider. We have teams escorting naval vessels through some of Bangladesh’s busiest naval and river routes. We have a dedicated team in Sylhet guarding one of the world’s longest 17km Long Belt Conveyor for Lafarge running between India and Bangladesh. We have secured the country’s largest telephone and mobile network towers of leading telecom providers like Robi, GP, Ericsson and more.</p>

          </div>

          <div className="fourthPera">
            <h2 className='chooseUsHeading'>Our Vigilance</h2>
            <p className='aboutperagraph'>Eagle Eye Security Service operates around the clock, every day of the year. You can count on us for prompt, rapid service at any hour.

</p>
          </div>
      </div>
    </div>
  )
}

export default ChooseUs
